import type * as api from '@gitbook/api-client';
import type { PaletteGroupDef } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { filterOutNullable } from '@gitbook/util-ts';

import type { NavigateFunction } from '../../../navigation';
import { getSpaceLanguageCommands } from '../../Space';

/**
 * Palette options relating to space management.
 */
export function getPaletteSpaceOptions(props: {
    space: api.Space;
    siteId: string;
    navigate: NavigateFunction;
}): PaletteGroupDef {
    const { space, siteId, navigate } = props;
    return {
        key: 'space-options',
        commands: [
            {
                key: 'view',
                title: 'Go to space',
                icon: Icon.Space,
                trigger: () => {
                    navigate({
                        screen: {
                            type: 'space',
                            organization: space.organization,
                            site: siteId,
                            space: space.id,
                            page: '',
                        },
                    });
                },
            },
            getSpaceLanguageCommands(space),
        ].filter(filterOutNullable),
    };
}
